export default __webpack_public_path__ + "static/media/gallery-wip-pommel_07.7665bb3b.jpg";